<script lang="ts">
  import { getList } from '../../services'
  import { currentPage, list, pagination as storePagination, tab } from '../../store'

  const tabs = [
    { title: 'Все посты', value: '' },
    { title: 'Отложенные', value: 'delayed' },
    { title: 'Опубликованные', value: 'all' },
    { title: 'Черновики', value: 'drafts' },
    { title: 'Деактивированные', value: 'deactivated' }
  ]

  const select = async (value) => {
    $tab = value
    const { results, pagination } = await getList()
    $list = results
    $currentPage = 1
    $storePagination = pagination
  }
</script>

<div class="tabs">
  {#each tabs as { value, title }}
    <div 
      class="tab" 
      class:active={$tab === value}
      on:click={() => select(value)}
    >
      {title}
    </div>  
  {/each}
</div>

<style lang="scss">
  .tabs {
    display: flex;
    margin-top: 24px;

    .tab {
      padding: 8px 15px;
      border-bottom: 1px solid #E0E8F6;
      cursor: pointer;
      font-weight: 600;
      line-height: 20px;
      color: #5A5F6D99;
      transition: color .3s, border-color .3s;
      font-size: 14px;

      &.active {
        border-bottom-color: #2B50ED;
        color: #2B50ED;
      }
    }
  }
</style>